import { ChevronRight, Clock } from 'lucide-react';
import { PENDING_BADGE } from 'components/Appointment/ConfirmAppointmentModal/helper';
import SectionRow from './SectionRow';
import { CARD } from './helper';

const SectionCard = ({ title, icon: Icon, iconBg, iconColor, rows, empty, completed, onView }) => (
  <button
    type="button"
    onClick={onView}
    aria-label={`View ${title.toLowerCase()} details`}
    className={`${CARD} group w-full text-left transition-colors hover:bg-secondary-50`}
  >
    <div className="flex items-center gap-3 border-b border-gray-100 px-4 py-3">
      <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${iconBg}`}>
        <Icon size={16} className={iconColor} />
      </div>

      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-secondary-900">{title}</p>

        {!completed && (
          <span className={`${PENDING_BADGE} mt-0.5`}>
            <Clock size={10} />
            Pending
          </span>
        )}
      </div>

      <span className="inline-flex shrink-0 items-center gap-0.5 text-xs font-semibold text-secondary-900 transition-colors group-hover:text-teamcare-blue">
        View
        <ChevronRight size={14} />
      </span>
    </div>

    <div className="grid grid-cols-2 gap-x-4 px-4">
      {empty ? (
        <p className="col-span-2 py-3 text-xs text-secondary-400">{empty}</p>
      ) : (
        rows.map((row) => <SectionRow key={row.label} {...row} />)
      )}
    </div>
  </button>
);

export default SectionCard;
